import { render, staticRenderFns } from "./ri.vue?vue&type=template&id=04415592&"
import script from "./ri.vue?vue&type=script&lang=ts&"
export * from "./ri.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports